import theme from "../theme"

import { makeUnauthGetRequest } from "../lambda/unauthRequests"
import {
  makePostRequest as postRequest,
  makeGetRequest as getRequest,
  makePutRequest as putRequest,
  makePatchRequest as patchRequest,
  makeDeleteRequest as deleteRequest,
} from "../lambda/requests"

export default (mapState) => (state, ownProps) => ({
  theme,
  makeUnauthGetRequest,
  postRequest,
  getRequest,
  putRequest,
  patchRequest,
  deleteRequest,
  permissions: state.sessionReducer.permissions,
  ...mapState(state, ownProps),
})
